export function getCountryInfo(code: string = 'za') {
  const countries: Record<string, { name: string; lang: string }> = {
    za: { name: 'South Africa', lang: 'en-ZA' },
    ng: { name: 'Nigeria', lang: 'en-NG' },
    ke: { name: 'Kenya', lang: 'en-KE' },
    et: { name: 'Ethiopia', lang: 'am-ET' },
    gh: { name: 'Ghana', lang: 'en-GH' },
    eg: { name: 'Egypt', lang: 'ar-EG' },
    ma: { name: 'Morocco', lang: 'ar-MA' },
    us: { name: 'United States', lang: 'en-US' }
  };
  return countries[code.toLowerCase()] || { name: 'Africa', lang: 'en' };
}
